import { render, staticRenderFns } from "./VitalChart.vue?vue&type=template&id=b080ef10&scoped=true&"
import script from "./VitalChart.vue?vue&type=script&lang=js&"
export * from "./VitalChart.vue?vue&type=script&lang=js&"
import style0 from "./VitalChart.vue?vue&type=style&index=0&id=b080ef10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b080ef10",
  null
  
)

export default component.exports